import React from 'react';
import { formatTime } from './activityUtils';

/**
 * Common timer component for activities
 * @param {Object} props - Component props
 * @param {number} props.count - Current count in seconds
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.displayFormat - Display format ('circle' | 'box' | 'text')
 * @returns {JSX.Element} Timer component
 */
const ActivityTimer = ({ 
  count, 
  className = '', 
  displayFormat = 'circle' 
}) => {
  const renderTimer = () => {
    switch (displayFormat) {
      case 'circle':
        return (
          <div className={`timer-circle ${className}`}>
            <span className="timer-text">{formatTime(count)}</span>
          </div>
        );
      
      case 'box':
        return (
          <div className={`timer-box ${className}`}>
            <span className="timer-icon">🕒</span>
            <span className="timer-text">{formatTime(count)}</span>
          </div>
        );
      
      case 'text':
      default:
        return (
          <span className={`timer-text ${className}`}>
            {formatTime(count)}
          </span>
        );
    }
  };

  return renderTimer();
};

export default ActivityTimer;
